module.exports = __webpack_public_path__ + "static/linomat_slide-8b4bcd3e243ae34deef04a4b309e0a42.jpeg";